<script>
  export default {
    name: 'SeckillPrice',
    props: {
      name: String,
      value: {
        type: [Number, String],
        required: true,
      },
      type: {
        type: String,
        default: 'highlight',
        validator(val) {
          return [
            'highlight',
            'delete',
          ].includes(val);
        },
      },
    },
    render(h) {
      const tagName = this.type === 'delete' ? 'del' : 'div';
      return h(
        tagName,
        {
          class: {
            'seckill-price-component': true,
            [`seckill-price--${this.type}`]: true,
          },
        },
        [
          h('span', {
            class: {
              'seckill-price-name': true,
            },
          }, this.name),
          h('span', {
            class: {
              'seckill-price-value': true,
            },
            domProps: {
              innerHTML: `&nbsp;${this.value}元`,
            },
          }),
        ],
      );
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .seckill-price {
    &-component {
      display: flex;
      align-items: flex-end;
    }

    &--highlight {
      font-size: @font-size-medium;
      font-weight: @font-weight-bold;
      color: @seckill-highlight;
    }

    &--delete {
      display: inline-flex;
      @price-delete-padding: 6px;
      position: relative;
      color: @color-text-lighter;
    }

    &-value {
      flex-shrink: 0;
    }
  }
</style>
